export function isPlainJSObject(x: any) {
   return x && x.__proto__ === Object.prototype;
}
